module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f641.9dc0c15c.svg";